import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import './ReceivedCarePage.scss';

export class ReceivedCarePage extends Component {
  render() {

    let person = "they";
    if (this.props.forMe) {
      person = "you";
    }

    const title = "Have " + person + " received care at Cleveland Clinic within the last three years?";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "icon-button-order",
        inputs: [
          {
            type: 'icon-button',
            id: "yes",
            className: "btn--icon btn--yes",
            icon: "yes",
            value: 'Yes',
            onClick: () => {
              this.props.webAppointmentSetPatientSeenRecently(true);
              this.props.history.push(nextPage(null, { forMe: this.props.forMe, patientSeenRecently: true }));
            }
          },
          {
            type: 'icon-button',
            id: "no",
            className: "btn--icon btn--no",
            icon: "no",
            value: 'No',
            onClick: () => {
              this.props.webAppointmentSetPatientSeenRecently(false);
              this.props.history.push(nextPage(null, { forMe: this.props.forMe, patientSeenRecently: false }));
            }
          },
          {
            type: 'icon-button',
            id: "i-dont-know",
            className: "btn--icon btn--not-sure",
            icon: "not-sure",
            value: "Not sure",
            onClick: () => {
              this.props.webAppointmentSetPatientSeenRecently(false);
              this.props.history.push(nextPage(null, { forMe: this.props.forMe, patientSeenRecently: false }));
            }
          },
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--secondary",
            value: 'Back',
            onClick: () => {
              this.props.history.goBack();
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

ReceivedCarePage.propTypes = {
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetPatientSeenRecently: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetPatientSeenRecently: (value) => dispatch(webAppointmentActions.webAppointmentSetPatientSeenRecently(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(ReceivedCarePage);
